import styled from '@emotion/styled';
import '../../../assets/colors.scss';
const ImportantPageStyle = styled('div')`
    border-radius: 8px;
    background: rgb(255, 255, 255);
    box-shadow: rgba(156, 171, 194, 0.4) 4px 4px 20px 0px;
    padding: 32px;
    margin-bottom: 2rem;
    line-height: 1.4;

    .title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 24px;
    }

    ul {
        list-style: disc;
    }

    @media screen and (max-width: 767px) {
        padding: 24px;
    }
    @media print {
        break-inside: avoid;
        page-break-inside: avoid;
        margin-top: 24px;
        border: 1px solid rgb(220, 220, 220);
        box-shadow: none;
    }
`;
export default ImportantPageStyle;
